import { render } from "./ComboAplicacaoAcrescimoDesconto.vue?vue&type=template&id=7d336e20&ts=true"
import script from "./ComboAplicacaoAcrescimoDesconto.vue?vue&type=script&lang=ts"
export * from "./ComboAplicacaoAcrescimoDesconto.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\OnSeller\\FrontEnd\\Admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__